import Cookies from 'js-cookie'

const WeixLoginInfo = 'Admin-WeixLoginInfo'
const LoginInfo = 'Admin-LoginInfo'
const WeixInfo = 'Admin-Weix'
const LoginType = 'Admin-LoginType'

//  微信登录信息
export function getWeixLoginInfo() {
  return Cookies.get(WeixLoginInfo)
}

export function setWeixLoginInfo(Info) {
  delete Info.sysRoleListInfos
  return Cookies.set(WeixLoginInfo, Info)
}

export function removeWeixLoginInfo() {
  return Cookies.remove(WeixLoginInfo)
}

//  账户密码登录信息
export function getLoginInfo () {
  return Cookies.get(LoginInfo)
}

export function setLoginInfo (Info) {
  delete Info.sysRoleListInfos
  return Cookies.set(LoginInfo, Info)
}

export function removeLoginInfo () {
  return Cookies.remove(LoginInfo)
}

//  微信信息
export function getWeixInfo () {
  return Cookies.get(WeixInfo)
}

export function setWeixInfo (Info) {
  return Cookies.set(WeixInfo, Info)
}

export function removeWeixInfo () {
  return Cookies.remove(WeixInfo)
}

//  登录类型
export function getLoginType() {
  return Cookies.get(LoginType)
}

export function setLoginType(type) {
  return Cookies.set(LoginType, type)
}

export function removeLoginType() {
  return Cookies.remove(LoginType)
}
